export default {
    parts: [],
    baseStyle: (props) => ({
        sectionTitle: {
            color: {base: 'webTypo.textPrimary', lg: 'webTypo.textSecondary'},
            textStyle: 'footer',
            fontWeight: 'medium',
            letterSpacing: '0',
            mt: {base: 0, lg: 0},
            mb: {base: 0, lg: 5}
        },
        footerLink: {
            color: {base: 'webTypo.textSecondary', lg: 'webTypo.textPrimary'},
            display: {base: 'inline-block'},
            textStyle: 'footer',
            letterSpacing: '0',
            marginTop: {base: 4, lg: 0},
            marginBottom: {base: 4, lg: 2}
        },
        accordionItem: {
            border: {base: '0'}
        },
        accordionButton: {
            color: 'webTypo.textPrimary',
            textStyle: 'footer',
            letterSpacing: {base: '0px'},
            paddingTop: {base: 3},
            paddingBottom: {base: 4},
            justifyContent: {base: 'space-between'}
        },
        accordionIcon: {
            transition: {base: 'transform 0.2s ease-in-out'},
            width: {base: '14px'},
            height: {base: '14px'},
            ...(props.isExpanded ? {
                transform: 'rotate(180deg)'
            } : {
                transform: 'rotate(0deg)'
            })
        },
        accordionPanel: {
            padding: {base: 0}
        },
        accordionPanelExpanded: {
            paddingTop: {base: 0},
            paddingRight: {base: 0},
            paddingBottom: {base: 3},
            paddingLeft: {base: 0}
        }
    })
}
